import React from 'react';

const ToggleContext = React.createContext({});

export default ToggleContext;
